export class Controller {
    /** @ngInject */
    constructor($state, Alert, DestructiveOperationModal) {
        this.$state = $state;
        this.Alert = Alert;
        this.DestructiveOperationModal = DestructiveOperationModal;
    }

    $onInit() {
    }

    remove() {
        this.isSaving = true;
        // ApplicationsResource.deleteApplication(this.companyId, this.application.id)
        const url = `app/rest/v2/company/${this.companyId}/applications/${this.application.id}`;
        const params = {action: 'delete'};
        this.DestructiveOperationModal({http: {method: 'DELETE', url, params}})
            .then(() => this.$state.go(({
                'custom': 'company.custom-app-integration',
                'computer-login': 'company.computer-protection',
                'computer-protection-without-ad': 'company.computer-protection',
            })[this.application.applicationType.slug] || 'company.applications'))
            .then(() => {
                this.Alert(
                    'success',
                    'company.manage-application.remove.removed',
                    {applicationName: this.application.applicationName},
                );
            })
            .finally(() => this.isSaving = false)
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/remove/remove-application.controller.js